var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bid-button",class:( _obj = {
		inactive: !_vm.getIsValid
	}, _obj[_vm.getType] = true, _obj.selected = _vm.selected, _obj[_vm.highlight] = true, _obj ),attrs:{"data-value":_vm.bid.value},on:{"click":_vm.clickBid}},[_c('V2Bid',{attrs:{"bid":_vm.bid,"showBackgroundColour":true,"showLongPass":_vm.showLongPass}}),(_vm.iconName && _vm.selected)?_c('icon',{staticClass:"bid-icon",attrs:{"icon":_vm.iconName,"colour":"transparent"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }